(function () {
  const SELECTOR = '[data-vrc]';
  const initialized = new WeakSet();

  function init(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const track = root.querySelector('[data-vrc-track]');
    const prevBtn = root.querySelector('[data-vrc-prev]');
    const nextBtn = root.querySelector('[data-vrc-next]');
    if (!track) return;

    const cards = () => Array.from(track.querySelectorAll('[data-vrc-card]'));

    const getActiveIndex = () => {
      const items = cards();
      if (items.length === 0) return 0;
      const trackRect = track.getBoundingClientRect();
      const viewportCenter = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let closestDist = Infinity;
      items.forEach((el, i) => {
        const rect = el.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        const dist = Math.abs(center - viewportCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    };

    const scrollToIndex = (i, behavior = 'smooth') => {
      const items = cards();
      if (items.length === 0) return;
      const clamped = Math.max(0, Math.min(items.length - 1, i));
      const card = items[clamped];
      const cardLeft = card.offsetLeft;
      const cardWidth = card.offsetWidth;
      const viewportWidth = track.clientWidth;
      const targetLeft = cardLeft - (viewportWidth - cardWidth) / 2;
      track.scrollTo({ left: Math.max(0, targetLeft), behavior });
      updateArrows(clamped);
    };

    const updateArrows = (activeIndex) => {
      const items = cards();
      if (prevBtn) prevBtn.disabled = activeIndex <= 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= items.length - 1;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollToIndex(getActiveIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollToIndex(getActiveIndex() + 1);
      });
    }

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollToIndex(getActiveIndex() - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollToIndex(getActiveIndex() + 1);
      }
    });

    let scrollTimer = null;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => updateArrows(getActiveIndex()), 80);
      },
      { passive: true }
    );

    cards().forEach((card) => {
      const playBtn = card.querySelector('[data-vrc-play]');
      const videoEl = card.querySelector('[data-vrc-video]');
      const hasPlayable = card.dataset.hasPlayable === 'true';

      const startVideo = () => {
        if (!videoEl || !hasPlayable) return;

        videoEl.setAttribute('controls', '');
        videoEl.muted = false;
        card.dataset.playing = 'true';

        const attempt = videoEl.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {
            videoEl.muted = true;
            const retry = videoEl.play();
            if (retry && typeof retry.catch === 'function') {
              retry.catch(() => {
                card.dataset.playing = 'false';
              });
            }
          });
        }
      };

      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          if (!hasPlayable) return;
          startVideo();
        });
      }

      card.addEventListener('click', (e) => {
        if (card.dataset.playing === 'true') return;
        // Let clicks on the native video controls (once shown) through.
        if (e.target && e.target.tagName === 'VIDEO') return;
        const index = parseInt(card.dataset.vrcIndex || '0', 10);
        const activeIndex = getActiveIndex();
        if (index === activeIndex) {
          if (e.target.closest('[data-vrc-play]')) return;
          if (hasPlayable) startVideo();
        } else {
          scrollToIndex(index);
        }
      });
    });

    requestAnimationFrame(() => {
      const initial = parseInt(track.dataset.initial || '0', 10) || 0;
      if (initial > 0) {
        scrollToIndex(initial, 'auto');
      } else {
        updateArrows(getActiveIndex());
      }
    });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        scrollToIndex(getActiveIndex(), 'auto');
      }, 150);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const el = e.target && e.target.querySelector ? e.target.querySelector(SELECTOR) : null;
    if (el) init(el);
  });
})();
